import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Bookings from './components/internal/Bookings'
import GolfTournament from './components/internal/GolfTournament'
import Residence from './components/internal/Residence/Residence'
import ContractsAndInvoices from './components/internal/ContractsAndInvoices'
import Companies from './components/admin/Companies'
import Applications from './components/admin/Applications'
import ApplicationWaitlist from './components/admin/ApplicationWaitlist'
import InformationRequests from './components/admin/InformationRequests'
import GolfClubRequests from './components/admin/GolfClubRequests'
import OverviewMap from './components/admin/OverviewMap'
import Members from './components/admin/Members'
import Contracts from './components/admin/Contracts'
import Invoices from './components/admin/Invoices'
import ResidenceBookings from './components/admin/ResidenceBookings'
import Blackboard from './components/internal/Blackboard'
import Offers from './components/internal/Offers'
import Hotels from './components/internal/Hotels'
import ErrorNotFound404 from './pages/ErrorNotFound404'
import CompanyDetail from './components/admin/CompanyDetail'
import MemberDetail from './components/admin/MemberDetail'
import ContractDetail from './components/admin/ContractDetail'
import InvoiceDetail from './components/admin/InvoiceDetail'
import ApplicationDetail from './components/admin/ApplicationDetail'
import Onboarding from './components/admin/Onboarding'
import CreateCompanyAndMember from './components/admin/CreateCompanyAndMember'
import Dashboard from './components/admin/Dashboard'
import EditRules from './components/admin/EditRules'
import Analytics from './components/admin/Analytics'

// import UserStore from './stores/UserStore'
import TournamentRegistrations from './components/admin/TournamentRegistrations';

// const AdminRoute = ({ component: Component, ...rest }) => (
//   <div>
//     <Route {...rest} render={props => (
//       UserStore.isLoggedIn ? (
//         <Component {...props} />
//       ) : (
//           <Redirect to={{
//             pathname: '/',
//             state: { from: props.location }
//           }} />
//         )
//     )} />
//   </div>
// )


const ReloadRoute = ({ ...rest }) => {
  return (
    <div>
      <Route {...rest} render={props => {
        location.reload()
        return
      }} />
    </div>
)}

const InternalRoutes = () => (
  <main>
    <Switch>
      {/* <Route exact path='/internal' component={Blackboard}/> */}
      {/* <Route exact path='/internal/offers' component={Offers}/> */}
      {/* <Route path='/internal/booking/:target' component={Bookings}/> */}
      {/* <Route path='/internal/booking' component={Bookings}/> */}
      {/* <Route path='/internal/contracts-invoices' component={ContractsAndInvoices}/> */}
      {/* <Route path='/internal/tournament' component={GolfTournament}/> */}
      <Route path='/internal/admin/tournamentregistrations' component={TournamentRegistrations}/>
      <Route exact path='/internal/admin/informationrequest' component={InformationRequests}/>
      <Route exact path='/internal/admin/applications' component={Applications}/>
      <Route exact path='/internal/admin/applicationwaitlist' component={ApplicationWaitlist}/>
      <Route path='/internal/admin/golfclubrequests' component={GolfClubRequests}/>
      <Route path='/internal/admin/map' component={OverviewMap}/>
      {/* <Route path='/internal/admin/applications/onboarding/:uid' component={Onboarding}/> */}
      <Route path='/internal/admin/applications/:uid' component={ApplicationDetail}/>
      <Route path='/internal/admin/onboarding/:uid' component={CreateCompanyAndMember}/>
      <Route path='/internal/admin/analytics' component={Analytics}/>
      <Route exact path='/internal/admin/companies' component={Companies}/>
      <Route path='/internal/admin/companies/:cid' component={CompanyDetail}/>
      <Route path='/internal/admin/members/:uid' component={MemberDetail}/>
      <Route path='/internal/admin/members' component={Members}/>
      <Route exact path='/internal/admin/contracts' component={Contracts}/>
      <Route path='/internal/admin/contracts/:uid' component={ContractDetail}/>
      <Route exact path='/internal/admin/invoices' component={Invoices}/>
      <Route path='/internal/admin/invoices/:uid' component={InvoiceDetail}/>
      <Route path='/internal/admin/residence' component={ResidenceBookings}/>
      <Route path='/internal/admin/rules' component={EditRules}/>
      <Route path='/internal/admin' component={Dashboard}/>
      {/* <Route path='/internal/residence' component={Residence}/> */}
      {/* <Route path='/internal/hotels/:uid' component={Hotels}/> */}
      {/* <Route path='/internal/hotels' component={Hotels}/> */}
      {/* <Route path="*" component={ErrorNotFound404} status={404} /> */}
      <ReloadRoute path="*" />
      <ReloadRoute exact path="/" />
    </Switch>
  </main>
)
export default InternalRoutes



// WEBPACK FOOTER //
// /src/InternalRoutes.js